

























import { Vue, Component } from 'vue-property-decorator'
import { BaseDownLoadCsv } from '@/utils/downFile'
@Component
export default class Step2 extends Vue {
  radio: string = '文件';
  form = {
    file: null,
    fileName: ''
  }

  fileUpload(e: any) {
    const { files } = e.target
    const { name } = files[0]
    this.form.file = files[0]
    this.form.fileName = name
  }

  vaildSubmit(cb: Function) {
    // eslint-disable-next-line standard/no-callback-literal
    cb(true, this.form)
  }
  downLoad(name:string) {
    BaseDownLoadCsv(name)
  }
}
